import { render, staticRenderFns } from "./Work2.vue?vue&type=template&id=3e159766&"
import script from "./Work2.vue?vue&type=script&lang=js&"
export * from "./Work2.vue?vue&type=script&lang=js&"
import style1 from "./Work2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports